import {observable, action} from 'mobx';
import categoriesAPI from "./bingCategoriesApi";


export default class BingCategoryStore {
  @observable
  isLoading = false;

  @observable
  loaded = false;

  @observable
  categories = [];

  @action
  loadCategories(){
    if(!this.categories.length && !this.isLoading && !this.loaded){
      this.isLoading = true;
      return categoriesAPI.getBingCategories().then(this.onCategoriesLoaded);
    }

    return Promise.resolve(this.categories);
  }

  @action.bound
  onCategoriesLoaded(resp) {
    this.categories = resp.categories;
    this.isLoading = false;
    this.loaded = true;
    return this.categories;
  }

  search = (query) => {
    const categories = this.categories;
    const lowercase = query.toLowerCase();
    return categories.filter(category => category.textLowercase.includes(lowercase));
  };
}